import * as React from 'react'
import { Link } from 'react-router-dom'

import { reportModalPageView } from '../../../common/analytics/userAnalytics'
import { config } from '../../../common/config'
import { getCurrentSiteDomain } from '../../../common/utils/sites'
import MarketHeaderContainer from '../../containers/marketHeaderContainer'
import { Props } from '../../containers/siteHeaderContainer'
import CategoriesMenu from '../categoriesMenu'
import CompactSearchBar from '../compactSearchBar/compactSearchBar'
import HeadBanner from '../headBanner'
import PageOffLeftMenu from '../pageOffCanvasLeft/pageOffLeftMenu'

import { getPageTypeFromLocation } from '../../../common/utils/location/getPageTypeFromUrl'
import { hasSearchPageQueryParams } from '../../../common/utils/location'
import { hasFeature } from '../../../common/utils/features'

import * as styles from './siteHeader.module.css'

const ssoServerHost = config.sso.SERVER_HOST

interface InternalLinkProps {
  title: string
  href: string
  className: string
  children: React.ReactNode
}

const SiteHeader = ({
  banners,
  currentSite,
  menuConfig,
  openModal,
  handleSignInSuccess,
  location,
  searchBar,
  experiments,
  makeSearchLink
}: Props) => {
  const pageOffLeftMenu = <PageOffLeftMenu items={menuConfig} />
  const pageOffLeftSearchBar = (
    <CompactSearchBar
      className={styles.offCanvasSearch}
      makeSearchLink={makeSearchLink}
      noBorder
    />
  )
  const headerConfigs = {
    ssoServerHost,
    rootDomain: `//${getCurrentSiteDomain(currentSite)}`
  }
  const onClickSignIn = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()
    reportModalPageView({
      title: 'Modal: direct sign in',
      page: '//direct-sign-in'
    })
    openModal({
      type: 'signIn',
      payload: {
        currentSite,
        onSignInSuccess: handleSignInSuccess,
        welcomeMsg: 'Great to have you back!',
        location,
        experiments
      }
    })
  }

  const InternalLink = (props: InternalLinkProps) => (
    <Link title={props.title} to={props.href} className={props.className}>
      {props.children}
    </Link>
  )

  const isCategoryPage =
    getPageTypeFromLocation(location, currentSite) === 'category' &&
    !hasSearchPageQueryParams(location.query)

  const shouldHideBanner =
    isCategoryPage &&
    hasFeature('hideBanner', currentSite, location, experiments)

  return (
    <div
      className={styles.headerWrapper}
      data-test-selector="global-header-wrapper"
      role="banner"
    >
      {!shouldHideBanner && <HeadBanner banners={banners} impressions={true} />}
      <MarketHeaderContainer
        enableAddCredit={false}
        currentSite={currentSite}
        mobileCategoriesMenu={pageOffLeftMenu}
        mobileCategoriesSearchBar={pageOffLeftSearchBar}
        onClickSignIn={onClickSignIn}
        configs={headerConfigs}
        InternalLink={InternalLink}
      />

      <div className={styles.headerCategoriesWrapper}>
        <div className={styles.headerCategories}>
          <div className={styles.gridWide}>
            <CategoriesMenu menuConfig={menuConfig} />
            {searchBar && (
              <CompactSearchBar
                className={styles.categoryNavigationSearch}
                makeSearchLink={makeSearchLink}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SiteHeader
